// extracted by mini-css-extract-plugin
export default {"bidsForPost":"user-bids_bidsForPost__3bfZh","seePost":"user-bids_seePost__-VrsG"};